import { searchActionTypes as actionTypes } from '../ActionTypes/searchActionTypes'
import commonActions from './commonActions'
import { httpFetch, httpFetchNoEncode } from '../Utils/httpUtils'

const searchActions = {
    search(input) {
        return dispatch => {
            if (!input) {
                dispatch(searchActions.emptySearchResult(true));
            }
            dispatch(searchActions.searchCustomers(input));
        }
    },

    searchGeneric(queryKey, input) {
        const inputEncoded = encodeURIComponent(input);
        return dispatch => {
            dispatch(searchActions.searchLoading(true));
            dispatch(commonActions.hideAlert());
            dispatch(searchActions.emptySearchResult());
            dispatch(commonActions.progressLoader(true));

            return httpFetchNoEncode(`/api/customer?${queryKey}=${inputEncoded}`, dispatch)
                .then(json => {
                    dispatch(searchActions.showResult({ input, data: json.results }));
                })
                .finally(() => {
                    dispatch(searchActions.searchLoading(false));
                });
        }
    },

    searchCustomers(input) {
        return searchActions.searchGeneric('searchPhrase', input);
    },

    searchByContactPerson(input) {
        return searchActions.searchGeneric('email', input);
    },

    searchByCustomerNumber(input) {
        return searchActions.searchGeneric('customerNumber', input);
    },

    searchByOrganizationNumber(input) {
        return searchActions.searchGeneric('organizationNumber', input);
    },
    
    searchLoading(json) {
        return {
            type: actionTypes.SEARCH_LOADING,
            json
        }
    },

    showResult(json) {
        return {
            type: actionTypes.SEARCH_CUSTOMER_RESULT,
            json
        }
    },

    emptySearchResult() {
        return {
            type: actionTypes.EMPTY_SEARCH_RESULTS
        }
    },

    searchInputChanged(newValue) {
        return {
            type: actionTypes.SEARCH_INPUT_CHANGED,
            value: newValue
        }
    }
}

export default searchActions;